export const FIRST_FETCH_CONFIGURED_TABLE = 'FIRST_FETCH_CONFIGURED_TABLE'
export const FIRST_FETCH_UNSET_CONFIGURED_TABLE = 'FIRST_FETCH_UNSET_CONFIGURED_TABLE'
export const FETCH_CONFIGURED_TABLE = 'FETCH_CONFIGURED_TABLE'
export const FETCH_DATA_FROM_TABLE = 'FETCH_DATA_FROM_TABLE'
export const CLEAN_TABLE_STATE = 'CLEAN_TABLE_STATE'
export const CLEAR_TABLE_DATA = 'CLEAR_TABLE_DATA'
export const FETCH_DATA_TABLE_WITH_PARAMS = 'FETCH_DATA_TABLE_WITH_PARAMS'
export const FETCH_MORE_DATA_ON_TABLE = 'FETCH_MORE_DATA_ON_TABLE'
export const HANDLE_FAST_FILTER = 'HANDLE_FAST_FILTER'
export const CHANGE_FAST_FILTER = 'CHANGE_FAST_FILTER'
export const CLEAR_STATUS = 'CLEAR_STATUS'
export const SET_VIEW_TABLE = 'SET_VIEW_TABLE'
export const TABLE_NOTIFICATION = 'TABLE_NOTIFICATION'
export const SET_TIMER = 'SET_TIMER'
export const FETCH_DATA_BY_STATUS = 'FETCH_DATA_BY_STATUS'
export const SET_LOAD_TYPE = 'SET_LOAD_TYPE'
export const SET_OFFER_PRICE = 'SET_OFFER_PRICE'
